document.addEventListener('DOMContentLoaded', setFranchiseWidget)
const FRANCHISE_ENDPOINT = 'https://hook.eu2.make.com/v9wc7bndjjj57c8t1n36my225qjvcfkg';

function setFranchiseWidget() {
    const franchiseWrapper = document.querySelector('.boa-sticky-franchise-container');
    const franchiseModal = document.querySelector('#franchiseModal');
    if (!franchiseWrapper || !franchiseModal) {
        return;
    }

    const anchorFranchiseElement = franchiseWrapper.querySelector('.sticky-franchise')
    anchorFranchiseElement.addEventListener('click', () => {
        franchiseModal.classList.add('show');
        document.body.style.overflow = 'hidden';
    })
}
async function handleSubmitForm(event) {
    event.preventDefault();

    const franchiseModal = document.querySelector('#franchiseModal');
    const anchorFranchiseText = document.querySelector('.boa-sticky-franchise-container .sticky-franchise');
    const isValid = validateForm();
    if(!isValid) {
        return;
    }

    try {
        const form = document.querySelector("#franchiseForm");
        const formData = new FormData(form);
        const formDataObject = Object.fromEntries(formData);
        
        const response = await fetch(FRANCHISE_ENDPOINT, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formDataObject)
        })
        if (!response.ok) {
            throw new Error('Server responded with error');
        }
        franchiseModal.classList.remove('show');
        document.body.style.overflow = '';
        anchorFranchiseText.textContent = "תודה רבה, ניצור איתך קשר";
        anchorFranchiseText.classList.add('success');
        form.reset();
    } catch (error) {
        anchorFranchiseText.textContent = "אירעה שגיאה בשליחת הטופס";
        document.body.style.overflow = '';
        franchiseModal.classList.remove('show');
    }
}


function validateForm() {
    let isValid = true;
    const requiredInputs = document.querySelectorAll('#franchiseForm .form-fields-required input');
    requiredInputs.forEach((input) => {
        const errorMessage = input.closest('.form-field').querySelector('.error-message');
        if (!input.value.trim()) {
            isValid = false;
            errorMessage.style.display = 'block'
        } else {
            errorMessage.style.display = 'none';
        }
    })
    return isValid;
}